import { render, staticRenderFns } from "./giftcards-to-me.vue?vue&type=template&id=9869d466&scoped=true&lang=html&"
import script from "./giftcards-to-me.vue?vue&type=script&lang=js&"
export * from "./giftcards-to-me.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9869d466",
  null
  
)

export default component.exports